import { CategoryGroupLink } from '@/features/Settings/api/services/training/searchQuestionnaireCategoryGroups';
import { SetQuestionnaireCategoryGroupsDocument } from '@/api/queries';
import graphApi from '@/api';

const [runSetCategoryGroups] = graphApi(SetQuestionnaireCategoryGroupsDocument);

export const updateCategoryGroups = async (categoryId: string, currentLinks: CategoryGroupLink[], groupIds: string[]): Promise<void> => {
  const currentGroupIds = currentLinks.map((link) => link.groupId);
  const unchanged = currentGroupIds.length === groupIds.length && groupIds.every((groupId) => currentGroupIds.includes(groupId));
  if (unchanged) return;
  await runSetCategoryGroups({ input: { questionnaireCategoryId: categoryId, groupIds } });
};

export default updateCategoryGroups;
